import AddVendorLocation from "pages/dashboard/add-vendor-location";
import { Modal } from "react-bootstrap";

const AddVendorLocationModal = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={() => {}}
      backdrop="static"
      keyboard={false}
      fullscreen
      centered
    >
      <Modal.Header
        closeButton
        closeVariant="white"
        style={{ borderBottom: "none", backgroundColor: "black" }}
      ></Modal.Header>

      <Modal.Body style={{ backgroundColor: "black", padding: 0 }}>
        <AddVendorLocation closeModal={handleClose} />
      </Modal.Body>
    </Modal>
  );
};

export default AddVendorLocationModal;
